var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading"
        }
      ],
      staticClass: "student_details_wrap"
    },
    [
      _c("div", { staticClass: "student_details_title" }, [
        _c("h2", [_vm._v("我的分数明细")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "计分规则：总成绩（100分） = 课件学习（" +
              _vm._s(_vm.scoreData.coursewareRate) +
              "）+单元测验（" +
              _vm._s(_vm.scoreData.unitExamRate) +
              "）+课程考试（" +
              _vm._s(_vm.scoreData.courseExamRate) +
              "）+考勤出勤率（" +
              _vm._s(_vm.scoreData.attendanceExamRate) +
              "）"
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "student_details_scoring" },
        [
          _c("div", [
            _c("b", [_vm._v(_vm._s(_vm.scoreData.sumScore))]),
            _vm._v(" "),
            _c("strong", [_vm._v("分")]),
            _vm._v(" "),
            _c("span", [_vm._v("当前课程总得分")])
          ]),
          _vm._v(" "),
          _c("span", [_vm._v("=")]),
          _vm._v(" "),
          _c("div", [
            _c("b", [_vm._v(_vm._s(_vm.scoreData.coursewareScore))]),
            _vm._v(" "),
            _c("strong", [_vm._v("分")]),
            _vm._v(" "),
            _c("span", [_vm._v("课件学习")])
          ]),
          _vm._v(" "),
          _c("span", [_vm._v("+")]),
          _vm._v(" "),
          _c("div", [
            _c("b", [_vm._v(_vm._s(_vm.scoreData.unitExamScore))]),
            _vm._v(" "),
            _c("strong", [_vm._v("分")]),
            _vm._v(" "),
            _c("span", [_vm._v("单元测验")])
          ]),
          _vm._v(" "),
          _c("span", [_vm._v("+")]),
          _vm._v(" "),
          _c("div", [
            _c("b", [_vm._v(_vm._s(_vm.scoreData.courseExamScore))]),
            _vm._v(" "),
            _c("strong", [_vm._v("分")]),
            _vm._v(" "),
            _c("span", [_vm._v("课程考试")])
          ]),
          _vm._v(" "),
          _c("span", [_vm._v("+")]),
          _vm._v(" "),
          _c("div", [
            _c("b", [_vm._v(_vm._s(_vm.scoreData.attendanceExamScore))]),
            _vm._v(" "),
            _c("strong", [_vm._v("分")]),
            _vm._v(" "),
            _c("span", [_vm._v("考勤")])
          ]),
          _vm._v(" "),
          _vm.scoreData.showFlag == 1
            ? _c(
                "el-button",
                { staticClass: "relearning", on: { click: _vm.relearningFn } },
                [_vm._v("重新学习")]
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "student_details_tab" },
        [
          _c(
            "el-tabs",
            {
              model: {
                value: _vm.activeName,
                callback: function($$v) {
                  _vm.activeName = $$v
                },
                expression: "activeName"
              }
            },
            [
              _c(
                "el-tab-pane",
                { attrs: { label: "课件学习", name: "first" } },
                [
                  _vm.activeName == "first"
                    ? _c("CoursewareLearning", {
                        attrs: {
                          courseId: _vm.courseId,
                          classId: _vm.classId,
                          userId: _vm.userId
                        }
                      })
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-tab-pane",
                { attrs: { label: "单元测验", name: "second" } },
                [
                  _vm.activeName == "second"
                    ? _c("UnitTest", {
                        attrs: {
                          courseId: _vm.courseId,
                          classId: _vm.classId,
                          userId: _vm.userId
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c44c4ff6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c44c4ff6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/studyCenter/switch/achievement/student/index.vue
// module id = null
// module chunks = 